// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_tLF","cls2":"JournalSubscriptionPage-cls2_Igc JournalSubscriptionPage-cls1_tLF"};